// ClickUp: https://app.clickup.com/t/86e205h8t
(function () {


    const SelectorsDictionary = {
        ChannelCentralProdInput: 'input.id_channelCentrolProd',
    }
    const BODY_CLASS = 'fe-hpe-4072';

    /**
     * HPE's native getChannelData() reads $("input.id_channelCentrolProd").val().length
     * whenever the URL has a query string. On PDPs that are not "channel central product"
     * pages the server does not render that hidden input, so .val() is undefined and
     * .length throws a TypeError that breaks the page (models/customize flow).
     *
     * This runs before Angular's ngAfterViewInit fires. If the URL has a query string and
     * the input is missing, we inject an empty hidden input so .val() returns "" (length 0)
     * and the native guard evaluates to falsy — matching the intended non-channel behavior.
     */
    function ensureChannelCentralProdInput() {
        try {
            if (!location.search) {
                return;
            }
            if ($(SelectorsDictionary.ChannelCentralProdInput).length) {
                return;
            }
            $('body').append('<input type="hidden" class="id_channelCentrolProd" value="">');
            window.feHPEB2C?.log?.(feProjectId + ': injected placeholder id_channelCentrolProd input');
        } catch (error) {
            window.feHPEB2C?.log?.(feProjectId + ': failed to inject id_channelCentrolProd input', error);
        }
    }

    function init() {
        $('body').addClass(BODY_CLASS);
        ensureChannelCentralProdInput()

    }

    window.feUtils.waitForConditions({
        conditions: ['body'],
        activity: feProjectId,
        callback: init,
    })

})();
